import React from 'react';
import _ from 'lodash';
import styles from '../AccessBackOfficePermission.css';
import Row from './Row';

class Menu extends React.Component {
  render() {
    const { menu, submenu } = this.props;
    const isMenuChecked = this._isAllSubMenuChecked();
    return (
      <div className="col-lg-12">
        {this._hasSubMenu() && (
          <div
            className={`${styles['access-backoffice-permission-has-submenu']} ${
              !isMenuChecked && this._hasSubMenuChecked() > 0
                ? 'partial-checked'
                : ''
            }`}
          >
            <div className="checkbox checkbox-primary">
              <input
                type="checkbox"
                id={Menu._removeSpace(menu)}
                checked={isMenuChecked}
                onChange={this._onChangeMenuCheckbox}
                className="partial-checked"
              />
              <label for={Menu._removeSpace(menu)}>{menu}</label>
            </div>
          </div>
        )}
        {submenu.map(permission => {
          return (
            <Row
              key={permission.id}
              checked={this._isSubMenuChecked(permission)}
              onChangeCheckbox={this._onChangeSubMenuCheckbox}
              permission={permission}
              isSinglePermissionRow={!this._hasSubMenu()}
            />
          );
        })}
      </div>
    );
  }

  _hasSubMenu = () => {
    const { menu, submenu } = this.props;
    return submenu[0].sub_menu_name !== menu;
  };

  static _removeSpace(str) {
    return str.replace(/\s+/g, '');
  }

  _isAllSubMenuChecked = () => {
    const { fields, submenu } = this.props;
    const currentValue = fields.getAll();

    for (let i = 0; i < submenu.length; i++) {
      if (!_.find(currentValue, { id: submenu[i].id })) {
        return false;
      }
    }

    return true;
  };

  _hasSubMenuChecked = () => {
    const { fields, submenu } = this.props;
    const currentValue = fields.getAll();

    for (let i = 0; i < submenu.length; i++) {
      if (_.find(currentValue, { id: submenu[i].id })) {
        return true;
      }
    }

    return false;
  };

  _onChangeMenuCheckbox = () => {
    const nextState = !this._hasSubMenuChecked();
    const { fields, submenu } = this.props;
    const currentValue = fields.getAll();

    if (nextState) {
      for (let i = 0; i < submenu.length; i++) {
        const permission = submenu[i];
        const index = _.findIndex(currentValue, { id: permission.id });
        if (index === -1) {
          fields.push(permission);
        }
      }
    } else {
      const listIndex = [];
      for (let i = 0; i < submenu.length; i++) {
        const permission = submenu[i];
        const index = _.findIndex(currentValue, { id: permission.id });
        if (index !== -1) {
          listIndex.push(index);
        }
      }
      // this logic below is necessary, because when one of the obj
      // removed from the array, the index will shift hence we should
      // remove from the largest index first so it wont affect lowest index
      const descendedSortedIndex = listIndex.sort((a, b) => b - a);
      descendedSortedIndex.forEach(index => {
        fields.remove(index);
      });
    }
  };

  _isSubMenuChecked = permission => {
    const { fields } = this.props;
    const currentValue = fields.getAll();
    return _.findIndex(currentValue, { id: permission.id }) !== -1;
  };

  _onChangeSubMenuCheckbox = permission => {
    const { fields } = this.props;
    const currentValue = fields.getAll();
    const index = _.findIndex(currentValue, { id: permission.id });
    if (index === -1) {
      fields.push(permission);
    } else {
      fields.remove(index);
    }
  };
}

export default Menu;
